import { useAtom } from '@reatom/npm-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { profileAtom } from '@root/entities/profile'
import { ProfileCoinsMobile } from '@root/features/profile/profile-coins/ui/profile-coins-mobile'
import { Drawer } from '@root/shared/ui-kit'

import type { DrawerProps } from '@root/shared/ui-kit'

type Props = Pick<DrawerProps, 'onOpenChange' | 'open'> & {
  renderFooter?: () => React.ReactNode
}

export const CoinsDrawer: React.FC<Props> = ({
  open,
  onOpenChange,
  renderFooter,
}) => {
  const { t } = useTranslation()
  const [profile] = useAtom(profileAtom)

  const footer = renderFooter?.()

  return (
    <Root
      open={open}
      onOpenChange={onOpenChange}
      title={t('common.coins_other')}
    >
      <Content>
        {profile ? (
          <ProfileCoinsMobile delugeId={profile.delugeId} />
        ) : undefined}
        {footer ? <Footer>{footer}</Footer> : undefined}
      </Content>
    </Root>
  )
}

const Root = styled(Drawer)`
  height: var(--max-drawer-height);
`

const Content = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;

  height: 100%;
  gap: 12px;
  position: relative;
`

const Footer = styled.div`
  padding: 0 12px 12px;
`
